const eventData ={
  size: 202,
  laod:[
   {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },
   {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },
   {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },  {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },
   {
   
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'clear',
       sequence: 1667,
       firedAt: '2023-01-13T06:34:20.394Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
     
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'singleselect',
       name: 'update',
       sequence: 1668,
       firedAt: '2023-01-13T06:34:20.768Z',
     },
     eventPayload: {
       widgetId: 'VH460923_8',
       widgetElement: 'SingleSelect',
       optionResponse: [
         {
           value: '1',
           selected: false,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
         {
           value: '2',
           selected: true,
           eliminated: false,
           inputValue: '',
           errors: [],
         },
       ],
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'previous',
       sequence: 1669,
       firedAt: '2023-01-13T06:34:21.493Z',
     },
     eventPayload: 0,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'exit',
       adcUIActionType: 'EXIT_ITEM',
       sequence: 1670,
       firedAt: '2023-01-13T06:34:21.495Z',
     },
     eventPayload: 0,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH336085',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'enter',
       adcUIActionType: 'ENTER_ITEM',
       sequence: 1671,
       firedAt: '2023-01-13T06:34:21.562Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '26',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '86.20689655172413',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH336085',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'next',
       sequence: 1672,
       firedAt: '2023-01-13T06:34:21.987Z',
     },
     eventPayload: 1,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '26',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '86.20689655172413',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH336085',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'exit',
       adcUIActionType: 'EXIT_ITEM',
       sequence: 1673,
       firedAt: '2023-01-13T06:34:21.989Z',
     },
     eventPayload: 1,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '26',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '86.20689655172413',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'enter',
       adcUIActionType: 'ENTER_ITEM',
       sequence: 1674,
       firedAt: '2023-01-13T06:34:22.049Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'next',
       sequence: 1675,
       firedAt: '2023-01-13T06:34:23.003Z',
     },
     eventPayload: 1,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'exit',
       adcUIActionType: 'EXIT_ITEM',
       sequence: 1676,
       firedAt: '2023-01-13T06:34:23.005Z',
     },
     eventPayload: 1,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'enter',
       adcUIActionType: 'ENTER_ITEM',
       sequence: 1677,
       firedAt: '2023-01-13T06:34:23.385Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1678,
       firedAt: '2023-01-13T06:34:24.322Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731853',
         value: { optionValue: '2', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1679,
       firedAt: '2023-01-13T06:34:24.322Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731853',
         value: { optionValue: '2', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1680,
       firedAt: '2023-01-13T06:34:24.681Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731854',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1681,
       firedAt: '2023-01-13T06:34:24.681Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731854',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1682,
       firedAt: '2023-01-13T06:34:25.093Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731858',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1683,
       firedAt: '2023-01-13T06:34:25.093Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731858',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1684,
       firedAt: '2023-01-13T06:34:25.501Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731855',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1685,
       firedAt: '2023-01-13T06:34:25.501Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731855',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1686,
       firedAt: '2023-01-13T06:34:25.781Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731860',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1687,
       firedAt: '2023-01-13T06:34:25.781Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731860',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1688,
       firedAt: '2023-01-13T06:34:26.191Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731857',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1689,
       firedAt: '2023-01-13T06:34:26.191Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731857',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1690,
       firedAt: '2023-01-13T06:34:26.624Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731859',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1691,
       firedAt: '2023-01-13T06:34:26.624Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731859',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1692,
       firedAt: '2023-01-13T06:34:27.039Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731856',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1693,
       firedAt: '2023-01-13T06:34:27.039Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731856',
         value: { optionValue: '3', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'previous',
       sequence: 1694,
       firedAt: '2023-01-13T06:34:31.124Z',
     },
     eventPayload: 0,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'exit',
       adcUIActionType: 'EXIT_ITEM',
       sequence: 1695,
       firedAt: '2023-01-13T06:34:31.126Z',
     },
     eventPayload: 0,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'enter',
       adcUIActionType: 'ENTER_ITEM',
       sequence: 1696,
       firedAt: '2023-01-13T06:34:31.233Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'next',
       sequence: 1697,
       firedAt: '2023-01-13T06:34:32.026Z',
     },
     eventPayload: 1,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH460923',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'exit',
       adcUIActionType: 'EXIT_ITEM',
       sequence: 1698,
       firedAt: '2023-01-13T06:34:32.028Z',
     },
     eventPayload: 1,
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '28',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '93.10344827586206',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'item',
       name: 'enter',
       adcUIActionType: 'ENTER_ITEM',
       sequence: 1699,
       firedAt: '2023-01-13T06:34:32.126Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'more',
       sequence: 1700,
       firedAt: '2023-01-13T06:34:35.862Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'scroll',
       name: 'bottomreached',
       sequence: 1701,
       firedAt: '2023-01-13T06:34:35.862Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'scroll',
       name: 'trigger',
       sequence: 1702,
       firedAt: '2023-01-13T06:34:35.971Z',
     },
     eventPayload: { x: 0, y: 2 },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '2',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'clear',
       sequence: 1703,
       firedAt: '2023-01-13T06:34:36.148Z',
     },
     eventPayload: { widgetId: 'VH731852_10', widgetElement: 'Grid' },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '2',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'button',
       name: 'top',
       sequence: 1704,
       firedAt: '2023-01-13T06:34:36.745Z',
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '2',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'User',
       entity: 'scroll',
       name: 'trigger',
       sequence: 1705,
       firedAt: '2023-01-13T06:34:36.852Z',
     },
     eventPayload: { x: 0, y: 0 },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1706,
       firedAt: '2023-01-13T06:34:37.197Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731853',
         value: { optionValue: '4', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1707,
       firedAt: '2023-01-13T06:34:37.197Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731853',
         value: { optionValue: '4', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1708,
       firedAt: '2023-01-13T06:34:37.679Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731854',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1709,
       firedAt: '2023-01-13T06:34:37.679Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731854',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1710,
       firedAt: '2023-01-13T06:34:37.963Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731858',
         value: { optionValue: '4', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1711,
       firedAt: '2023-01-13T06:34:37.963Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731858',
         value: { optionValue: '4', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1712,
       firedAt: '2023-01-13T06:34:38.438Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731855',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1713,
       firedAt: '2023-01-13T06:34:38.438Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731855',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1714,
       firedAt: '2023-01-13T06:34:38.726Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731860',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1715,
       firedAt: '2023-01-13T06:34:38.726Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731860',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
   {
     context: {
       participant: '2GK0KF',
       blockCode: '2323MA3S01QSTX20EX',
       accessionNumber: 'VH731852',
     },
     version: '1.0.0',
     screen: { scene: 'n/a', screenIdentifier: 'n/a' },
     eventData: {
       initiatedBy: 'System',
       entity: 'grid',
       name: 'update',
       sequence: 1716,
       firedAt: '2023-01-13T06:34:39.006Z',
     },
     eventPayload: {
       widgetId: 'VH731852_10',
       widgetElement: 'Grid',
       optionResponse: {
         id: 'VH731857',
         value: { optionValue: '1', inputValue: '', hasTextInput: false },
       },
     },
     appStateAfterEvent: {
       isCalculatorShown: false,
       isEquationEditorOpen: false,
       isHelpShown: false,
       isNextButtonEnabled: true,
       isPaused: false,
       isPreviousButtonEnabled: true,
       isScratchworkActive: false,
       isTimerActive: true,
       isTTSActive: false,
       activeDialogName: 'None',
       activeItemSequence: '30',
       activeLanguage: 'en_US',
       activeTheme: 'default',
       activeZoomLevel: '1',
       aspectRatioScaleFactor: '0.7875',
       blockTimeElapsed: '180',
       blockType: 'CSQ',
       horizontalScrollOffset: '0',
       itemLanguage: 'en_US',
       progressPercentage: '100',
       scratchworkInputMode: 'pencil',
       toolbarLabelsAndTooltipsLanguage: 'en_US',
       verticalScrollOffset: '0',
     },
   },
 ]
 };
 
 export default eventData;
 